/* eslint-disable max-len */
import { useCallback, useEffect, useState } from 'react'
import useForm from 'tennders-common/form/hooks/useForm'
import useSalesInvoiceModal from 'tennders-finance/common/hooks/useSalesInvoiceModal'
import PubSub from 'pubsub-js'
import { apiGet } from 'tennders-stracture/libs/api'

type Props = {
  onFormChange: (index:number, data: Record<string, any>) => void;
  index: number
  initialErrors ?: Record<string, any>,
  vatPercentage ?: number,
  irpf ?: number,
  transactionId ?: number
}

const useMultipleCostInvoiceRow = (props : Props) => {
  const {
    onFormChange,
    index,
    initialErrors,
    vatPercentage: initialVatPercentage
  } = props
  const { form, setform, onChange, errors } = useForm({
    initialForm: {
      priceOnInvoice: 0,
      vatPercentage: initialVatPercentage || '',
      irpfDiscount: 0,
      concept: 'Transport',
      transactionId: null,
      paymentTerm: null,
      referenceNumber: null
    },
    initialErrors
  })

  const [transaction, setTransaction] = useState(null)
  const agreedPrice = transaction?.matchedTruck?.totalPrice
  const paidAmount = 0 // transaction?.costInvoices ? transaction?.costInvoices.reduce((acc, item) => acc + item.amount, 0) : 0
  const vatPercentage = form.vatPercentage ? (parseFloat(form.vatPercentage as string) / 100) : 0
  const priceOnInvoice = parseFloat(form.priceOnInvoice as unknown as string)
  const vatAmount = priceOnInvoice * vatPercentage
  const toBePaid = (priceOnInvoice + vatAmount) - (paidAmount)
  const totalAmount = priceOnInvoice + vatAmount
  const fetchTransactionDetail = async (id) => {
    const data = await apiGet(
      '/transactions/' + id,
      { query: { attributes: '{id,referenceNumber,createdAt {d}, matchedTruck{totalPrice, bookRate, id, paymentTerm{days}, cmrDocument{name, fullUri}},salesInvoice{id, uniqueFileName}, hasSalesInvoice, costInvoices{id}}' } }
    )
    setTransaction(data)
    onChange('transactionId', id)
  }

  const onTransactionChange = (transaction) => {
    if (!transaction) {
      return
    }
    setTransaction(transaction)
    const pendingAmount = transaction?.pendingAmounts?.reduce((acc, item) => acc + item.amount, 0) || 0
    //  onChange('priceOnInvoice', transaction?.matchedTruck?.totalPrice + pendingAmount)
    setform({
      ...form,
      priceOnInvoice: transaction?.matchedTruck?.totalPrice + pendingAmount,
      paymentTerm: transaction.matchedTruck?.paymentTerm,
      referenceNumber: transaction?.referenceNumber
    })
  }

  const onCloseSalesInvoice = useCallback((fetch) => {
    fetch({ ...transaction, hasSalesInvoice: true }).then(data => {
      setTransaction(prev => ({
        ...prev,
        salesInvoice: data[0]
      }))
    })
  }, [transaction])

  const { initializeSalesInvoice, salesInvoiceModal, loading } = useSalesInvoiceModal({ onClose: onCloseSalesInvoice, transaction })

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(`multiple-cost-invoice:${index}:change`, (msg, data) => {
      if (data.transactionId) {
        fetchTransactionDetail(data.transactionId)
      }
      setform(prevState => ({ ...prevState, ...data }))
    })
    return () => PubSub.unsubscribe(unsubscribe)
  }, [index])

  useEffect(() => {
    if (initialVatPercentage !== null) {
      setform({ ...form, vatPercentage: initialVatPercentage })
    }
  }, [initialVatPercentage])

  useEffect(() => {
    if (onFormChange) {
      onFormChange(index, {
        ...form,
        difference: agreedPrice - priceOnInvoice,
        agreedPrice,
        referenceNumber: transaction?.referenceNumber,
        transactionId: transaction?.id,
        vatAmount,
        toBePaid,
        totalAmount,
        concept: form.concept
      })
    }
  }, [
    form,
    onFormChange,
    index,
    priceOnInvoice,
    totalAmount,
    agreedPrice,
    toBePaid,
    form.concept
  ])

  return {
    toBePaid,
    agreedPrice,
    transaction,
    form,
    onChange,
    setTransaction,
    onTransactionChange,
    errors,
    initializeSalesInvoice,
    salesInvoiceModal,
    salesInvoiceLoading: loading

  }
}

export default useMultipleCostInvoiceRow
